<a
  *ngIf="item && !item.subNavigationItems?.length; else submenuTrigger"
  class="link-row {{ item.class }}"
  [attr.href]="item.href"
  [attr.data-test]="item.testAttribute"
  [trackClickData]="item.trackClickData"
  target="_self"
  mat-menu-item
  modeTrackClick
  (click)="onClick($event, item.testAttribute)"
>
  <capra-icon [icon]="item.icon"></capra-icon>
  <div class="menu-text">
    <span class="menu-item-title" data-test="menu-item-title">{{ item.title }}</span>
    <span class="menu-item-subtitle" data-test="menu-item-subtitle">{{ item.subtitle }}</span>
  </div>
</a>

<ng-template #submenuTrigger>
  <button
    *ngIf="item?.subNavigationItems?.length"
    class="link-row submenu-trigger"
    [attr.data-test]="item.testAttribute"
    mat-menu-item
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="submenu"
  >
    <capra-icon [icon]="item.icon"></capra-icon>
    <div class="menu-text">
      <span class="menu-item-title" data-test="menu-item-title">{{ item.title }}</span>
      <span class="menu-item-subtitle" data-test="menu-item-subtitle">{{ item.subtitle }}</span>
    </div>
    <capra-icon icon="icon-chevron-right"></capra-icon>
  </button>
  <mat-menu #submenu="matMenu" class="submenu-panel" xPosition="before" (closed)="onSubmenuClosed()">
    <div (mouseenter)="onSubmenuMouseEnter()" (mouseleave)="onSubmenuMouseLeave()">
      <a
        *ngFor="let subItem of item.subNavigationItems"
        class="link-row {{ subItem.class }}"
        [attr.href]="subItem.href"
        [attr.data-test]="subItem.testAttribute"
        [trackClickData]="subItem.trackClickData"
        target="_self"
        mat-menu-item
        modeTrackClick
        (click)="onClick($event, subItem.testAttribute)"
      >
        <capra-icon [icon]="subItem.icon"></capra-icon>
        <div class="menu-text">
          <span class="menu-item-title" data-test="menu-item-title">{{ subItem.title }}</span>
          <span class="menu-item-subtitle" data-test="menu-item-subtitle">{{ subItem.subtitle }}</span>
        </div>
      </a>
    </div>
  </mat-menu>
</ng-template>
